export default __webpack_public_path__ + "static/2-ede980a87b83acb991277c98a343eea5.png";